import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Camera, Contact, Phone, Video, Check, X, Inbox } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Avatar } from "@/components/Avatar";
import { FullSpinner, Empty } from "@/components/States";
import { toast } from "sonner";

const ICON = { photo: Camera, contact: Contact, voice: Phone, video: Video };
const SCLS = { pending: "text-amber-700 bg-amber-50", accepted: "text-emerald-700 bg-emerald-50", declined: "text-rose-700 bg-rose-50" };

export default function Requests() {
  const nav = useNavigate();
  const [tab, setTab] = useState("incoming");
  const [data, setData] = useState(null);

  const load = () => api.get("/requests").then(({ data }) => setData(data));
  useEffect(() => { load(); }, []);
  if (!data) return <FullSpinner />;

  const respond = async (id, action) => { try { await api.post(`/requests/${id}/${action}`); toast.success("Updated"); load(); } catch (e) { toast.error(apiError(e)); } };
  const items = tab === "incoming" ? data.incoming : data.outgoing;

  return (
    <div className="space-y-5" data-testid="requests-page">
      <h1 className="font-serif text-3xl font-bold text-[#58111A]">Requests</h1>
      <div className="flex gap-2">
        {[["incoming", "Incoming"], ["outgoing", "Sent"]].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} className={`text-sm font-medium px-4 py-2 rounded-full border ${tab === k ? "bg-[#781826] text-white border-[#781826]" : "bg-white border-[#E8DFD1] text-[#605255]"}`}>{l}</button>
        ))}
      </div>
      {items.length === 0 ? (
        <Empty icon={Inbox} title="No requests" message="Photo, contact, voice and video requests appear here." />
      ) : (
        <div className="space-y-3">
          {items.map((r) => {
            const Icon = ICON[r.kind] || Inbox;
            const pr = r.profile;
            return (
              <div key={r.id} className="mj-card p-4 flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl overflow-hidden shrink-0 cursor-pointer" onClick={() => nav(`/app/profile/${tab === "incoming" ? r.from_user : r.to_user}`)}><Avatar photos={pr?.photos} name={pr?.full_name} size={9999} className="w-full h-full" /></div>
                <div className="flex-1 min-w-0">
                  <div className="font-serif text-lg font-semibold text-[#261A1C]">{pr?.full_name}</div>
                  <div className="text-xs text-[#605255] flex items-center gap-1.5"><Icon className="w-3.5 h-3.5 text-[#C59B27]" /> {r.kind.charAt(0).toUpperCase() + r.kind.slice(1)} request</div>
                  <span className={`inline-block mt-1 text-[11px] font-semibold px-2 py-0.5 rounded-full ${SCLS[r.status]}`}>{r.status}</span>
                </div>
                {tab === "incoming" && r.status === "pending" && (
                  <div className="flex gap-2">
                    <button onClick={() => respond(r.id, "accept")} className="btn-primary text-sm py-1.5 px-3"><Check className="w-4 h-4" /></button>
                    <button onClick={() => respond(r.id, "decline")} className="btn-outline text-sm py-1.5 px-3"><X className="w-4 h-4" /></button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
